<template>
  <section class="main-container"></section>
</template>

<style src="./style.less" lang="less" scoped></style>
